module.exports = __webpack_public_path__ + "img/pssicon.cceff034.svg";